var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUsaa = function SvgUsaa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "usaa_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".usaa_svg__st1{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b3359"
    },
    d: "M0 0h40v40H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "usaa_svg__Calque_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "usaa_svg__st1",
    d: "M7.9 25.1v4.5c0 2.5 1.6 2.9 2.9 2.9 1.9 0 2.8-1.2 2.8-2.9v-4.4h-1.3v4.5c0 .6-.2 1.7-1.5 1.6-1.2 0-1.5-1.1-1.5-1.8v-4.4H7.9zm10.9.3s-.8-.4-1.7-.4c-1.1 0-2.6.6-2.6 2.2 0 1.1.8 1.6 1.4 1.9.3.1.7.3 1 .5.2.1.8.3.8.9 0 .7-.8.9-1.1.9-1.2 0-2.1-.6-2.1-.6l.1 1.4s.5.3 2 .3c1.4 0 2.5-.9 2.5-2.2 0-1-.7-1.5-1.2-1.8-.5-.2-.7-.3-1.1-.5s-.8-.5-.8-1 .5-.9 1.2-.9c1.1 0 1.5.5 1.7.6l-.1-1.3zm10.2-.3h-1.5l.2.6-2.4 6.1-2.3-6.7h-1.5l.2.6-2.5 6.5h1.4l.4-1.3h2.6l.4 1.3h2.6l.4-1.3h2.6l.4 1.3h1.5L29 25.1zm-7.6 4.8 1-2.8.9 2.8h-1.9zm6 0 1-2.8.9 2.8h-1.9zM7.8 17l.1 2.3s.6-.4 1.2-.4 1.3.4 1.3.4l5.6 3.2.5-2-6.1-3.5s-.7-.4-1.3-.4c-.6 0-1.3.4-1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "usaa_svg__st1",
    d: "m7.8 14.1.1 2.3s.6-.4 1.2-.4 1.3.4 1.3.4l6.2 3.6.5-2-6.7-3.9s-.7-.4-1.3-.4c-.6 0-1.3.4-1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "usaa_svg__st1",
    d: "m7.8 11.1.1 2.3s.6-.4 1.2-.4 1.3.4 1.3.4l6.8 3.9.5-2-7.3-4.2s-.7-.4-1.3-.4c-.6 0-1.3.4-1.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "usaa_svg__st1",
    d: "m19.5 7.7.6 2.7 8.5 4.8s.7.4 1.3.4c.7 0 1.3-.5 1.3-.5v-2.2s-.5.4-1.2.4-1.3-.4-1.3-.4l-6.6-3.8-.5-1.7c0-.1.1-.1.1-.1l1.1-.3c.2.1.2.2.2.3l.1.1.2-.1v-.7c0-.5-.4-.8-.8-.8h-1.1s-.2-.4-.6-.4h-2.1c-.6 0-.7.5-.7.5l-1.6 5.8-6-3.5s-.7-.4-1.3-.4c-.7 0-1.3.5-1.3.5l.1 2.3s.5-.4 1.2-.4 1.3.4 1.3.4l7.4 4.3 1.7-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "usaa_svg__st1",
    d: "m20.3 10.9.6 2.7 7.7 4.5s.7.4 1.3.4 1.3-.5 1.3-.5v-2.2s-.5.4-1.2.4-1.3-.4-1.3-.4l-8.4-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "usaa_svg__st1",
    d: "m21.1 14.4.6 2.7 6.9 4s.7.4 1.3.4 1.3-.5 1.3-.5v-2.2s-.5.4-1.2.4-1.3-.4-1.3-.4l-7.6-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "usaa_svg__st1",
    d: "m21.9 17.8.6 2.7 6.1 3.6s.7.4 1.3.4c.6 0 1.3-.5 1.3-.5v-2.3s-.5.4-1.2.4-1.3-.4-1.3-.4l-6.8-3.9z"
  }))));
};
export default SvgUsaa;